import { militaryMessagesEN } from './lib/intl/en-US';
import { militaryMessagesES } from './lib/intl/es';

export const programId = '5e6f9aa713abf31d084de9d2';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': militaryMessagesEN,
        es: militaryMessagesES,
    },
};
